import PostulationForm from './postulation_form/index';

const reCaptcha = document.querySelector('meta[name="hiringroom:recapcha"]').getAttribute('content');
const cloudflareRecaptcha = document.querySelector('meta[name="hiringroom:cloudflare_recapcha"]')?.getAttribute('content') || null;
PostulationForm({ reCaptcha, cloudflareRecaptcha });
